import {
	getBuildingFormObjectSchema,
	withBuildingRequiredMinimum,
} from "web_myplann/Portfolio/Forms/BuildingShared/buildingFormSchema";
import type { TranslateFunction } from "web_myplann/Shared/TranslateFunction";
import type { z } from "zod";

export const getFlatFormSchema = (t: TranslateFunction) =>
	withBuildingRequiredMinimum(
		getBuildingFormObjectSchema(t).omit({ numberOfFloors: true }),
	);

export type FlatFormInput = z.input<ReturnType<typeof getFlatFormSchema>>;
export type FlatFormOutput = z.output<ReturnType<typeof getFlatFormSchema>>;
